import { render, staticRenderFns } from "./ModalDocumentView.vue?vue&type=template&id=dd8f4e8c&scoped=true"
import script from "./ModalDocumentView.vue?vue&type=script&lang=js"
export * from "./ModalDocumentView.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumentView.vue?vue&type=style&index=0&id=dd8f4e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8f4e8c",
  null
  
)

export default component.exports